import {List, Record} from 'immutable';

const State = Record({
  new_favorites: List(),
  new_retweets: List(),
  likes_retweets_dates: List(),

  new_followers: List(),
  new_friends: List(),
  new_tweets: List(),
  total_followers: List(),
  total_friends: List(),
  total_tweets: List(),
  followers_friends_tweets_dates: List(),

  replies_mentions_sums: List(),
  replies_mentions_dates: List()

});

const engage = (state = new State(), action) => {

  switch (action.type) {


    case 'SET_NEW_FAVORITES':
      return state.set('new_favorites', action.value);

    case 'SET_NEW_RETWEETS':
      return state.set('new_retweets', action.value);

    case 'SET_LIKES_RETWEETS_DATES':
      return state.set('likes_retweets_dates', action.value);


    case 'SET_NEW_FOLLOWERS':
      return state.set('new_followers', action.value);

    case 'SET_NEW_FRIENDS':
      return state.set('new_friends', action.value);

    case 'SET_NEW_TWEETS':
      return state.set('new_tweets', action.value);

    case 'SET_TOTAL_FOLLOWERS':
      return state.set('total_followers', action.value);

    case 'SET_TOTAL_FRIENDS':
      return state.set('total_friends', action.value);

    case 'SET_TOTAL_TWEETS':
      return state.set('total_tweets', action.value);

    case 'SET_FOLLOWERS_FRIENDS_TWEETS_DATES':
      return state.set('followers_friends_tweets_dates', action.value);


    case 'SET_REPLIES_MENTIONS_SUMS':
      return state.set('replies_mentions_sums', action.value);

    case 'SET_REPLIES_MENTIONS_DATES':
      return state.set('replies_mentions_dates', action.value);

    default:
      return state;
  }
};


export default engage;


// WEBPACK FOOTER //
// ./src/reducers/engage-reducer.js